export default __webpack_public_path__ + "static/media/maxine_detail9.4fc16a35.jpg";